import { render, staticRenderFns } from "./ShowSlidesInfo.vue?vue&type=template&id=4207c2f8&scoped=true&"
import script from "./ShowSlidesInfo.vue?vue&type=script&lang=ts&"
export * from "./ShowSlidesInfo.vue?vue&type=script&lang=ts&"
import style0 from "./ShowSlidesInfo.vue?vue&type=style&index=0&id=4207c2f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4207c2f8",
  null
  
)

export default component.exports